import { Dispatch, SetStateAction, useMemo } from "react";

import { Button, Icon, SearchSVG } from "@newsela/angelou";

import {
  condensedSearchButtonCss,
  searchIconCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/CondensedSearchButton/CondensedSearchButton.styles";
import { SEARCH_MENU_ID } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";

const CondensedSearchButton = ({
  showSuggestions,
  setShowSuggestions,
}: ICondensedSearchButton) => {
  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen: showSuggestions,
        id: SEARCH_MENU_ID,
        ariaLabel: "Open Search Menu",
      }),
    [showSuggestions],
  );

  return (
    <Button
      ariaProps={buttonAriaProps}
      dataProps={{ "data-testid": "condensed-search-button", tabIndex: 0 }}
      __cssFor={condensedSearchButtonCss}
      flavor={Button.flavors.incognito}
      onClick={() => setShowSuggestions((showSuggestions) => !showSuggestions)}
    >
      <Icon SvgComponent={SearchSVG} __cssFor={searchIconCss} />
    </Button>
  );
};

interface ICondensedSearchButton {
  showSuggestions: boolean;
  setShowSuggestions: Dispatch<SetStateAction<boolean>>;
}

CondensedSearchButton.displayName = "CondensedSearchButton";
export { CondensedSearchButton };
